import React from "react";
import Grid from "../shared/Grid";

export default function Dashboard() {
  return <Grid>Dashboard</Grid>;
}
